/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TerminiVersioneDettaglioDTO { 
    versione?: number;
    sostanziale?: boolean;
    pubblicato_at?: string;
    pubblicato_da?: string;
    testo_it?: string;
    testo_en?: string;
}

